import { render } from "./SlickCarousel.vue?vue&type=template&id=0b611ef7"
import script from "./SlickCarousel.vue?vue&type=script&lang=js"
export * from "./SlickCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/common/SlickCarousel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b611ef7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b611ef7', __exports__)) {
    api.reload('0b611ef7', __exports__)
  }
  
  module.hot.accept("./SlickCarousel.vue?vue&type=template&id=0b611ef7", () => {
    api.rerender('0b611ef7', render)
  })

}


export default __exports__